import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  isSupported,
  logEvent as firebaseLogEvent,
  setAnalyticsCollectionEnabled,
} from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBSTvTLX44c_apqdZCfmLhs9dgzknjs5YU",
  authDomain: "crownedroofing-ea739.firebaseapp.com",
  projectId: "crownedroofing-ea739",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "crownedroofing-ea739.appspot.com",
  messagingSenderId: "915212766219",
  appId: "1:915212766219:web:90a765a64dc0c38a9b4b0e"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

let analytics = null;

const analyticsReady =
  typeof window === "undefined"
    ? Promise.resolve(null)
    : isSupported()
        .then((supported) => {
          if (!supported) return null;
          const analyticsInstance = getAnalytics(app);
          setAnalyticsCollectionEnabled(analyticsInstance, true);
          analytics = analyticsInstance;
          return analyticsInstance;
        })
        .catch(() => null);

function sanitizeAnalyticsParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null)
  );
}

export function logAnalyticsEvent(eventName, params = {}) {
  analyticsReady
    .then((analyticsInstance) => {
      if (!analyticsInstance || !eventName) return;
      firebaseLogEvent(analyticsInstance, eventName, sanitizeAnalyticsParams(params));
    })
    .catch(() => {});
}

export function trackPageView({ path, title, location } = {}) {
  logAnalyticsEvent("page_view", {
    page_path: path,
    page_title: title,
    page_location: location,
  });
}

export function trackWebVital(metric) {
  if (!metric) return;

  const numericValue =
    typeof metric.value === "number" ? Number(metric.value.toFixed(2)) : metric.value;
  const numericDelta =
    typeof metric.delta === "number" ? Number(metric.delta.toFixed(2)) : metric.delta;

  logAnalyticsEvent("web_vital", {
    metric_name: metric.name,
    metric_value: numericValue,
    metric_delta: numericDelta,
    metric_id: metric.id,
    metric_rating: metric.rating,
    non_interaction: true,
  });
}

export { analytics, analyticsReady, db, auth, storage };
